import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
} from '../'
import Styles from './ResolutionText.css'

@CSSModules(Styles, {allowMultiple: true})
export default class CampbellSoupResolutionText extends Component {
  render() {
    return (
      <div>
        <p>
          <Link
            to='https://www.asyousow.org/resolutions/2022/06/17-campbell-soup-report-on-aligning-retirement-plan-options-with-company-climate-goals'
            title={'Campbell Soup shareholder resolution'}
            xstrong
          >
            More resolution details<LinkIcon/>
          </Link>
        </p>
        <blockquote styleName='company-resolution-blockquote'>
          <p>
            <b>WHEREAS:</b> Shareholders applaud Campbell Soup Company for adopting ambitious operational climate goals, including reducing absolute Scope 1 and 2 greenhouse gas emissions 42 percent by FY2030, and reducing deforestation impact by purchasing 100 percent Roundtable on Sustainable Palm Oil certified palm oil by the end of FY2021.[1]
          </p>
          <p>
            While our company has made significant efforts to address climate change across its operations, data from Department of Labor filing,s including company retirement plan options and invested amounts, suggest to investors that Campbell’s is failing to address the material risks of climate change in its 401(k) Plan in alignment with the duty to select retirement plan investment options in the best interests of plan participants and beneficiaries.
          </p>
          <p>
            Campbell’s 401(k) Plan uses Vanguard funds as its default retirement option, resulting in the vast majority of its $1.9 billion employee retirement dollars, as of December 31, 2020,[2] invested in funds holding companies that create substantial climate risk. A recent scorecard, produced by investor representative As You Sow, shows that the Campbell’s 401(k) default option is rated Poor due to significant investments in fossil fuel companies and companies that cause deforestation risk.[3]
          </p>
          <p>
            Campbell’s does not offer any sustainable investment options inside the Plan, nor does it offer employees a “self-directed” investment option to choose other funds outside of the Plan.
          </p>
          <p>
            In polls with investors broadly, more than 70 percent say that they would like to invest sustainably and, specifically, not in oil, coal, and deforestation. In the increasingly competitive employee retention and recruitment landscape, failing to provide climate-safe retirement plan options may also make it more difficult for Campbell’s to attract and retain top talent.
          </p>
          <p>
            Given the threat that climate change poses to workers’ life savings, Campbell’s should demonstrate that it is safeguarding employee financial security over time by mitigating climate change-related financial and economic risks as part of a prudently constructed lineup of funds.
          </p>
          <p>
            Failing to satisfy this basic duty could be a liability for the Company, creating reputational risk and making it more difficult to retain employees increasingly concerned about catastrophic climate impacts.
          </p>
          <p>
            <b>BE IT RESOLVED:</b> Shareholders request the board provide a report assessing how the Company’s 401(k) retirement funds manage the growing systemic risk to the economy created by investing retirement Plan funds in companies contributing significantly to climate change.
          </p>
          <p>
            <b>SUPPORTING STATEMENT:</b> Such analysis should include, at Board discretion, whether Plan decisionmakers have considered:
          </p>
          <ol>
            <li>
              Climate risk in Company 401(k) Plan offerings;
            </li>
            <li>
              Whether including high carbon companies in Company 401(k) Plan contributes to greater economic volatility over time, and the impact of such volatility on retirement fund performance over time;
            </li>
            <li>
              Whether including high carbon companies contributing to climate change puts younger Plan participants’ retirement funds at greater economic risk than Plan participants nearer retirement age.
            </li>
          </ol>
        </blockquote>
      </div>
    )
  }
}